import { twMerge } from 'tailwind-merge';
import { LOGO_SRC } from './constants';
import { classes } from './utils';

export type HeaderLogoProps = {
  className?: string;
  src?: string | null;
};

export default function HeaderLogo({ className, src }: HeaderLogoProps) {
  return (
    <img
      className={twMerge(classes.logo, className)}
      alt="witMetrics logo"
      src={src || LOGO_SRC}
    />
  );
}
